"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.VerificationDealer = void 0;
const secret_value_to_string_1 = require("./secret-value-to-string");
class VerificationDealer {
    constructor(attestation) {
        this.attestation = attestation;
        this.revealedDuringVerification = new Set();
    }
    discloseSecrets(indexes, gameHash) {
        indexes.forEach((index) => this.revealedDuringVerification.add(index));
        try {
            return Promise.resolve(indexes.map((index) => {
                const disclosure = this.attestation.disclosures.find((disclosure) => disclosure.index == index);
                if (disclosure !== undefined) {
                    if (disclosure.hash !== gameHash) {
                        throw new Error(`Provided hash for index ${index} doesn't match (was ${disclosure.hash} expected ${gameHash})`);
                    }
                    return (0, secret_value_to_string_1.secretValueToString)(disclosure);
                }
                const secret = this.attestation.secrets.find((secret) => secret.index === index);
                if (secret === undefined) {
                    throw new Error(`Could not find secret for index ${index}`);
                }
                return (0, secret_value_to_string_1.secretValueToString)(secret);
            }));
        }
        catch (error) {
            return Promise.reject(error);
        }
    }
    hasForbiddenDisclosure() {
        return this.attestation.disclosures.some((disclosure) => !this.revealedDuringVerification.has(disclosure.index));
    }
}
exports.VerificationDealer = VerificationDealer;
